<template>
    <div class="uk-padding  uk-margin-remove-top">
        <div class="uk-container">
            <div uk-grid>
                <div class="uk-width-3-5@m" style=" z-index: 0;">
                    <img src="/admission3.jpg"  alt="">
                </div>
                <div class="uk-width-2-5@m uk-padding test" style="margin-left: -100px; z-index: 1;">
                    <div class="" style="background-color: rgb(3, 56, 96); height: 100%">
                        <div class="uk-padding">
                            <h3 class=" uk-light uk-text-left uk-text-uppercase " style="font-variant: all-small-caps; font-family: 'Nanum Gothic', sans-serif ">Undergraduate Admissions</h3>
                            <hr>
                            <div class="uk-text-small uk-light">
                                Join a long standing line of industry leaders that our institution constantly put out each year.
                                Take your first step to become the shining light of the class of 2024 today.
                                Shape your future today.
                            </div>
                            <br><br>
                            <router-link class="uk-align-right@m uk-light uk-text-small" style="border-bottom: 1px solid gold" to="/undergradadmission">
                                Undergraduate Admission
                                <span uk-icon="arrow-right"></span>
                            </router-link>
                            <!--<ul class="uk-list uk-list-bullet uk-text-left">
                                <li><a class="uk-light uk-text-left linkColor" href="#">Undergraduate Admission</a></li>
                                <li><a class="uk-light uk-text-left linkColor" href="#">Graduate Admissions</a></li>
                                <li><a class="uk-light uk-text-left linkColor" href="#">Transfer Students</a></li>
                                <li><a class="uk-light uk-text-left linkColor" href="#">International Students</a></li>
                                <li><a class="uk-light uk-text-left linkColor" href="#">International Students</a></li>
                            </ul>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "undergraduateAdmissions"
    }
</script>

<style scoped>
    .linkColor{
        color: white;
        font-variant: all-small-caps;
        font-size: 18px;
    }
    h3{
        color: rgba(255, 215, 3,0.9);
        font-family: soleil, sans-serif !important;
        font-style: normal;
        font-weight: 500;
    }
    @media screen and (max-width:600px){


        p,li{
            font-size: 0.8em !important;
        }
        .test{
            margin-left: auto !important;
        }

    }
</style>
